<div class="proyecto-container"
    [ngClass]="{'con-descuento' : estadoDescuentos !== EstadoDescuentosVC.SIN_DESCUENTOS, 'expandido': !productoVC.proyectoVC && hayCamposVisibles()}">
    <div class="proyecto-card">
        <div class="info-descuentos-card"
            *ngIf="estadoDescuentos !== EstadoDescuentosVC.SIN_DESCUENTOS && productoVC.descuento?.descuento">
            <ng-container *ngIf="estadoDescuentos === EstadoDescuentosVC.DISPONIBLES_SIN_PROYECTO">
                <ng-container
                    *ngIf="productoVC.proyectoVC?.esPrincipal && productoVC.descuento?.tipoDescuento === 'PAQUETIZACION'">
                    <div class="info-descuentos info-mensaje">
                        <label [innerHTML]="'PACKS.DESCUENTOS.SIN_PROYECTOS.PAQUETIZACION.PRINCIPAL' | translate:{ descuento:
                        productoVC.descuento.descuento }"></label>
                    </div>
                    <ng-container
                        *ngTemplateOutlet="bloqueInfoExtra; context: { descuento: productoVC.descuento.descuento }">
                    </ng-container>
                </ng-container>

                <div class="info-descuentos info-mensaje"
                    *ngIf="!productoVC.proyectoVC?.esPrincipal && productoVC.descuento?.tipoDescuento === 'PAQUETIZACION'">
                    <label [innerHTML]="'PACKS.DESCUENTOS.SIN_PROYECTOS.PAQUETIZACION.NO_PRINCIPAL' | translate:{ descuento:
                    productoVC.descuento?.descuento }"></label>
                </div>
            </ng-container>
            <ng-container *ngIf="estadoDescuentos === EstadoDescuentosVC.DISPONIBLES_CON_PROYECTO">

                <!-- Caso A: con proyecto seleccionado (o con proyecto descuento seleccionado) y paquetización -->
                <ng-container *ngIf="productoVC.proyectoVC !== null 
                    && (productoVC.proyectoVC.esSeleccionado || productoVC.proyectoDescuentoVC?.esSeleccionado) 
                    && productoVC.descuento?.tipoDescuento === 'PAQUETIZACION'; 
                    else sinProyectoPack">

                    <div class="info-descuentos info-mensaje">
                        <label [innerHTML]="'PACKS.DESCUENTOS.CON_PROYECTOS.PAQUETIZACION' | translate:{ descuento:
                        productoVC.descuento.descuento }"></label>
                    </div>
                    <ng-container
                        *ngTemplateOutlet="bloqueInfoExtra; context: { descuento: productoVC.descuento.descuento }">
                    </ng-container>
                </ng-container>

                <!-- Caso B (ELSE): no hay proyecto seleccionado (o ninguno de los dos seleccionados) -->
                <ng-template #sinProyectoPack>
                    <div class="info-descuentos info-mensaje"
                        *ngIf="productoVC.descuento?.tipoDescuento === 'PAQUETIZACION'">
                        <label [innerHTML]="'PACKS.DESCUENTOS.SIN_PROYECTOS.PAQUETIZACION.NO_PRINCIPAL' | translate:{ descuento:
                        productoVC.descuento.descuento}"></label>
                    </div>
                </ng-template>

            </ng-container>
        </div>

        <div class="producto-card"
            [ngClass]="{'expandido': !productoVC.proyectoVC && hayCamposVisibles(), 'producto-seleccionado': (productoVC.proyectoVC?.esSeleccionado === true || productoVC.proyectoDescuentoVC?.esSeleccionado ===true)}">
            <div class="producto-titulo" *ngIf="productoVC">
                <label [innerHTML]="productoVC.titulo"></label>
            </div>

            <ng-container
                *ngIf="(productoVC.proyectoVC !== null && (productoVC.proyectoVC.esSeleccionado || productoVC.proyectoDescuentoVC?.esSeleccionado)) else noProyecto">

                <ng-container
                    *ngIf="productoVC.configProyecto?.tipoTarificacionProyectoVc === TipoTarificacionProyectoVc.PRECIO_FIJO; else importesUI">
                    <div class="tarificacion">
                        {{ productoVC.configProyecto.mensajeTarificacion | isoCurrencyToSymbol }}
                    </div>
                </ng-container>

                <ng-template #importesUI>
                    <ng-container
                        *ngIf="estadoDescuentos === EstadoDescuentosVC.DISPONIBLES_CON_PROYECTO && productoVC.proyectoDescuentoVC; else importesNormales">
                        <div class="tarificacion">
                            {{productoVC.proyectoDescuentoVC?.impPrimaTotal | currency:'EUR':'symbol':'1.2-2' }}
                            <span class="periodo-total">{{'PACKS.PERIODICIDAD_ANUAL' | translate}}</span>

                        </div>
                        <div class="row recibos mt-3">
                            <div>
                                <p class="titulo-recibo">{{'COMUN.DATOS_ECONOMICOS.PRIMER_RECIBO' | translate}}</p>
                                <p class="precio-recibo">{{productoVC.proyectoDescuentoVC?.impPrimaPrimerRec |
                                    currency:'EUR':'symbol':'1.2-2' }}
                                    <ng-container *ngIf="getPeriodicidadProducto(productoVC) as per">
                                        <span class="periodicidad">/{{ per }}</span>
                                    </ng-container>
                                </p>
                            </div>
                            <div>
                                <p class="titulo-recibo">{{'COMUN.DATOS_ECONOMICOS.RECIBOS_SUCESIVOS' | translate}}</p>
                                <p class="precio-recibo">{{productoVC.proyectoDescuentoVC?.impPrimaRecSucesivos |
                                    currency:'EUR':'symbol':'1.2-2'}}
                                    <ng-container *ngIf="getPeriodicidadProducto(productoVC) as per">
                                        <span class="periodicidad">/{{ per }}</span>
                                    </ng-container>
                                </p>
                            </div>
                        </div>
                    </ng-container>

                    <ng-template #importesNormales>
                        <div class="tarificacion">
                            {{productoVC.proyectoVC?.impPrimaTotal | currency:'EUR':'symbol':'1.2-2' }}
                            <span class="periodo-total">{{'PACKS.PERIODICIDAD_ANUAL' | translate}}</span>
                        </div>
                        <div class="row recibos mt-3">
                            <div>
                                <p class="titulo-recibo">{{'COMUN.DATOS_ECONOMICOS.PRIMER_RECIBO' | translate}}</p>
                                <p class="precio-recibo">{{productoVC.proyectoVC?.impPrimaPrimerRec |
                                    currency:'EUR':'symbol':'1.2-2' }}
                                    <ng-container *ngIf="getPeriodicidadProducto(productoVC) as per">
                                        <span class="periodicidad">/{{ per }}</span>
                                    </ng-container>
                                </p>


                            </div>
                            <div>
                                <p class="titulo-recibo">{{'COMUN.DATOS_ECONOMICOS.RECIBOS_SUCESIVOS' | translate}}</p>
                                <p class="precio-recibo">{{productoVC.proyectoVC?.impPrimaRecSucesivos |
                                    currency:'EUR':'symbol':'1.2-2'}}
                                    <ng-container *ngIf="getPeriodicidadProducto(productoVC) as per">
                                        <span class="periodicidad">/{{ per }}</span>
                                    </ng-container>
                                </p>
                            </div>
                        </div>
                    </ng-template>
                </ng-template>
                <ng-container
                    *ngIf="(productoVC.proyectoVC.esSeleccionado === true || productoVC.proyectoDescuentoVC.esSeleccionado) else botonSeleccionarProy">
                    <ng-container *ngIf="!productoVC.proyectoVC.codPoliza && !productoVC.proyectoVC?.esPrincipal">
                        <div class="row recibos mt-2 botonera">
                            <ca-label class="col-12 texto-icono">{{'PACKS.BOTON_ELIMINAR' | translate}}</ca-label>
                            <div class="col-12">
                                <button class="boton-icono" ca-button-icon (click)="eliminarProductoVC()">
                                    <ca-icon class="icono_vc icono-grande">delete</ca-icon>
                                </button>
                            </div>
                        </div>

                    </ng-container>
                </ng-container>
                <ng-template #botonSeleccionarProy>
                    <div class="row recibos mt-2 botonera">
                        <ca-label class="col-12 texto-icono">{{'PACKS.BOTON_ANADIR' | translate}}</ca-label>
                        <div class="col-12">
                            <button class="boton-icono" ca-button-icon (click)="seleccionarProyectoVC()">
                                <ca-icon class="icono_vc icono-grande">add_box</ca-icon>
                            </button>
                        </div>
                    </div>
                </ng-template>
            </ng-container>

            <ng-template #noProyecto>
                <ng-container *ngIf="productoVC?.mensaje">
                    <label [innerHTML]="productoVC?.mensaje" class="mensaje-no-proyecto"></label>
                </ng-container>

                <ng-container *ngFor="let enlace of productoVC?.configProyecto?.enlaces; let i = index">
                    <ng-container *ngIf="enlace.tipoAperturaUrl === 'POPUP'">
                        <ng-container
                            *ngTemplateOutlet="bloqueInfoCoberturas; context: { enlace: enlace}"></ng-container>
                    </ng-container>

                    <ng-container *ngIf="enlace.tipoAperturaUrl === 'TAB'">
                        <ng-container
                            *ngTemplateOutlet="bloqueInfoRedireccion; context: { enlace: enlace }"></ng-container>
                    </ng-container>
                </ng-container>


                <ng-container *ngIf="hayCamposVisibles() else addIcon">
                    <button ca-button-icon class="mt-2"
                        (click)="hayCamposVisibles() ? toggleCampos() : anadirProductoVC()">
                        <ca-icon class="icono_vc">indeterminate_check_box</ca-icon>
                    </button>
                </ng-container>

                <ng-template #addIcon>
                    <div class="row recibos mt-2 botonera">
                        <ca-label class="col-12 texto-icono">{{'PACKS.BOTON_ANADIR' | translate}}</ca-label>
                        <div class="col-12">
                            <button class="boton-icono" ca-button-icon
                                (click)="hayCamposVisibles() ? toggleCampos() : anadirProductoVC()">
                                <ca-icon class="icono_vc icono-grande">add_box</ca-icon>
                            </button>
                        </div>
                    </div>
                </ng-template>

                <!-- Antes: *ngIf="productoVC?.configProyecto.camposProducto?.length" -->
                <div *ngIf="hayCamposVisibles()">
                    <form [formGroup]="form">
                        <div *ngFor="let campo of productoVC.configProyecto.camposProducto" class="mt-3">
                            <app-pregunta-venta-cruzada [campoProductoVC]="campo"
                                [form]="form"></app-pregunta-venta-cruzada>
                        </div>
                        <button class="mt-2 mb-2" type="button" ca-button [disabled]="form.invalid"
                            (click)="tarificarProductoVC()">Tarificar</button>
                    </form>
                </div>

            </ng-template>
        </div>
    </div>
</div>

<ng-template #bloqueInfoExtra let-descuento="descuento">
    <div class="info-descuentos info-extra">
        {{ 'PACKS.DESCUENTOS.INFORMACION.MAS_INFORMACION' | translate }}
        <button ca-button-icon (click)="mostrarModalInfoDescuentos(descuento)">
            <ca-icon class="icono_vc">info</ca-icon>
        </button>
    </div>
</ng-template>

<ng-template #bloqueInfoCoberturas let-enlace="enlace">
    <div class="mt-1">
        <a href="javascript:void(0)" (click)="mostrarModalInfoCoberturas(enlace.url)" class="urlProyecto">
            {{ enlace.txtTitulo }}
        </a>
    </div>
</ng-template>

<ng-template #bloqueInfoRedireccion let-enlace="enlace">
    <div class="mt-1">
        <a [href]="enlace.url" target="_blank" rel="noopener noreferrer" class="urlProyecto">
            {{ enlace.txtTitulo }}
        </a>
    </div>
</ng-template>